import { KeycloakService } from 'src/app/angularJS/services/keycloak.service';

import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';

export class ResponseInterceptor {
  public responseError: Function;

  constructor(
    private $q: ng.IQService,
    private $rootScope: ng.IRootScopeService,
    private $injector: ng.auto.IInjectorService,
    private keycloakService: KeycloakService
  ) {
    this.responseError = (response) => { return this.responseErrorFunction(response); };
  }

  public responseErrorFunction(response) {
    (<any>this.$rootScope).showSpinner = false;

    response.errorTitle = 'There has been a problem';

    switch (response.status) {
      case 401: {
        this.keycloakService.logout();
        break;
      }
      case 403: {
        response.errorMessage = 'You are not authorised to view this content. Please contact your system administrator.';
        (<ng.ui.IStateService>this.$injector.get('IStateService')).go('home');
        (<UserMessagesService>this.$injector.get('UserMessages')).showErrorDialog(response);
        break;
      }
      case 404: {
        response.errorMessage = 'We could not find that content. Please try again later.';
        (<UserMessagesService>this.$injector.get('UserMessages')).showErrorDialog(response);
        break;
      }
      case 503: {
        response.errorMessage = 'This content is unavailable. Please try again later.';
        (<UserMessagesService>this.$injector.get('UserMessages')).showErrorDialog(response);
        break;
      }
      case 504: {
        response.errorMessage = 'There is a network issue. Please try again later.';
        (<UserMessagesService>this.$injector.get('UserMessages')).showErrorDialog(response);
        break;
      }
      default: {
        response.errorMessage = 'There has been a problem with our system. Please try again later.';
        (<UserMessagesService>this.$injector.get('UserMessages')).showErrorDialog(response);
        break;
      }
    }

    return this.$q.reject(response);
  }
}